import { Form, Input, Modal, notification, Select } from 'antd';
import { t } from 'i18next';
import { VacationModel, VacationReq } from 'models/workSchedule';
import React from 'react'
import UseCreateVacation from 'hooks/query/workSchedule/UseCreateVacation';
import { useQueryClient } from 'react-query';


interface AddVacationProps {
  openAddVication: boolean;
  setOpenAddVication: (openAddOfficalHoliday: boolean) => void;
  selectedVacation: VacationModel | null
  setSelectedVacation: (selectedVacation: VacationModel | null) => void
}

const options: {key: string; value: number}[] = [
    {
        key: 'annual',
        value: 1
    },
    {
        key: 'sick',
        value: 2
    },
    {
        key: 'hourly',
        value: 3
    },
    {
        key: 'other',
        value: 4
    },
];

const AddVacation = ({openAddVication, setOpenAddVication, selectedVacation, setSelectedVacation}: AddVacationProps) => {
    const [form] = Form.useForm();
    const responseCreateVacation = UseCreateVacation();
    const queryClient = useQueryClient()

    const onFinish = async (values: any) => {
        const payload: VacationReq = {
            start_date: values.start_date,
            end_date: values.end_date,
            type: values.type,
            note: values.note
        };
        if (payload.note === undefined || payload.note === null) {
            delete payload.note;
        }
        if(payload.start_date) {
        payload.start_date = payload.start_date.replace("T", " ");
        }
        if (payload.end_date) {
        payload.end_date = payload.end_date.replace("T", " ");
        }
        responseCreateVacation
            .mutateAsync(payload)
            .then(() => {
            queryClient.invalidateQueries({
            queryKey: ['my-vacation'],
            });
            notification.open({
                type: 'success',
                message: t('vacation_created_successfully'),
            });
            handleClose();
            })
            .catch(() => {});
    }

    const handleClose = () => {
        setOpenAddVication(false);
        setSelectedVacation(null);
        form.resetFields();
    };
    return (
        <Modal
            title={t('add_vacation')}
            open={openAddVication}
            centered
            destroyOnClose
            onCancel={handleClose}
            closable={{ 'aria-label': 'Custom Close Button' }}
            okButtonProps={{ loading: responseCreateVacation.isLoading}}
            onOk={() => {form.submit()}}>
            <Form form={form} onFinish={onFinish} labelCol={{ span: 24 }}>
                <div style={{ marginBottom: '30px' }}>
                    <p>{t('start_date_vacation')}</p>
                    <Form.Item
                        name="start_date"
                        rules={[{ required: true, message: t('please_enter_start_date') }]}
                    >
                        <Input 
                        type="datetime-local" 
                        />
                    </Form.Item>
                </div>
                <div style={{ marginBottom: '30px' }}>
                    <p>{t('end_date_vacation')}</p>
                    <Form.Item
                        name="end_date"
                        rules={[{ required: true, message: t('please_enter_end_date') }]}
                    >
                        <Input 
                        type="datetime-local"
                        />
                    </Form.Item>
                </div>
                <div style={{marginBottom: "30px"}}>
                    <p>{t("vacation_type")}</p>
                    <Form.Item
                        name="type"
                        rules={[{ required: true, message: t("please_select_type_of_vacation") }]}
                    >
                        <Select
                            allowClear
                            style={{ width: '100%', height: '40px' }}
                            placeholder={t("please_select")}
                            options={options.map((element) => ({ label: t(element.key), value: element.value }))}
                        />
                    </Form.Item>
                </div>
                <Form.Item
                label={t('note')}
                name="note"
                style={{ marginBottom: '10px' }}
                >
                <Input />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AddVacation